import React from 'react';
import SectionCard from './SectionCard';
import {Card} from "react-bootstrap";
import '../styles/SectionCard.css';
import { useLanguage } from '../LanguageContext';
const About = () => {
    const { translations } = useLanguage();
    return (
        <Card className="section-card">
            <Card.Body>
                <Card.Title>
                    <img src="/images/PDBF_final-02.png" alt="Logo" width={200} height={200}/>
                </Card.Title>
                <Card.Text>
                    <div className="row">
                        <h1>{translations.about.subTitle}</h1>
                    </div>
                    <div className="row text-center">
                        <h2>{translations.about.patrickTitle}: {translations.about.patrickTitleDescription}</h2>
                    </div>
                        <img
                            src="/images/Patrick-Main.png"
                            alt="patrick"
                            className="rounded-circle img-fluid"
                            style={{
                                width: "75%",      // Makes it responsive
                                maxWidth: "550px",  // Limits size on large screens
                                aspectRatio: "1 / 1", // Ensures it stays a perfect square
                                objectFit: "cover",
                                borderRadius: "50%", // Ensures full roundness
                                margin: "15px"
                            }}
                        />

                    <div className="row">
                        <p>{translations.about.patrickContent}</p>
                        <p>{translations.about.patrickContent1}</p>
                        <p>{translations.about.patrickContent2}</p>
                    </div>

                    <div className="row text-center" style={{margin: "15px"}}>
                            <div className="col">
                                <div className="row text-center">
                                    <h2>{translations.about.matthiasTitle}: {translations.about.matthiasTitleDescription}</h2>
                                    <div className="col d-flex justify-content-center">
                                        <img
                                            src="/images/Matthias-Main.png"
                                            alt="matthias"
                                            className="rounded-circle"
                                            style={{width: "250px", height: "250px", objectFit: "cover", margin: "5px"}}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <p>{translations.about.matthiasContent}</p>
                                </div>

                            </div>
                            <div className="col">
                                <div className="row text-center">
                                    <h2>{translations.about.adrianTitle}: {translations.about.adrianTitleDescription}</h2>
                                    <div className="col d-flex justify-content-center">
                                        <img
                                            src="/images/Adrian-Main.png"
                                            alt="adrian"
                                            className="rounded-circle"
                                            style={{width: "250px", height: "250px", objectFit: "cover", margin: "5px"}}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <p>{translations.about.adrianContent}</p>
                                </div>
                            </div>

                        </div>

                        <div className="row" style={{padding: "15px"}}>
                            {translations.about.footerContent}
                            <img src="/images/Team-Main.jpg" alt="Logo" className="rounded-circle w-50 mx-auto d-block"
                                 style={{margin: "25px", width:"450"}}/>
                        </div>

                        <div className="row justify-content-center" style={{padding: "15px"}}>
                            {translations.about.footer}
                        </div>


                </Card.Text>
            </Card.Body>
        </Card>
);
};

export default About;